"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainflexSeriesSchema = void 0;
const zod_1 = require("zod");
const InputJsonValue_1 = require("../inputTypeSchemas/InputJsonValue");
const DataSourceSchema_1 = require("../inputTypeSchemas/DataSourceSchema");
const ChainflexCategorySchema_1 = require("../inputTypeSchemas/ChainflexCategorySchema");
const VelocityUnitSchema_1 = require("../inputTypeSchemas/VelocityUnitSchema");
const AccelerationUnitSchema_1 = require("../inputTypeSchemas/AccelerationUnitSchema");
const LengthUnitSchema_1 = require("../inputTypeSchemas/LengthUnitSchema");
/////////////////////////////////////////
// CHAINFLEX SERIES SCHEMA
/////////////////////////////////////////
exports.ChainflexSeriesSchema = zod_1.z.object({
    dataSource: DataSourceSchema_1.DataSourceSchema,
    categories: ChainflexCategorySchema_1.ChainflexCategorySchema.array(),
    mainCategory: ChainflexCategorySchema_1.ChainflexCategorySchema,
    speedMaxUnsupportedUnit: VelocityUnitSchema_1.VelocityUnitSchema.nullish(),
    accelerationMaxUnsupportedUnit: AccelerationUnitSchema_1.AccelerationUnitSchema.nullish(),
    travelDistanceUnsupportedUnit: LengthUnitSchema_1.LengthUnitSchema.nullish(),
    speedMaxGlidingUnit: VelocityUnitSchema_1.VelocityUnitSchema.nullish(),
    accelerationMaxGlidingUnit: AccelerationUnitSchema_1.AccelerationUnitSchema.nullish(),
    travelDistanceGlidingUnit: LengthUnitSchema_1.LengthUnitSchema.nullish(),
    speedMaxVerticalUnit: VelocityUnitSchema_1.VelocityUnitSchema.nullish(),
    accelerationMaxVerticalUnit: AccelerationUnitSchema_1.AccelerationUnitSchema.nullish(),
    travelDistanceVerticalUnit: LengthUnitSchema_1.LengthUnitSchema.nullish(),
    echainId: zod_1.z.string(),
    akeneoCode: zod_1.z.string(),
    description: InputJsonValue_1.InputJsonValue,
    unsupportedAllowed: zod_1.z.boolean(),
    speedMaxUnsupported: zod_1.z.number().nullish(),
    accelerationMaxUnsupported: zod_1.z.number().nullish(),
    travelDistanceUnsupported: zod_1.z.number().nullish(),
    glidingAllowed: zod_1.z.boolean(),
    speedMaxGliding: zod_1.z.number().nullish(),
    accelerationMaxGliding: zod_1.z.number().nullish(),
    travelDistanceGliding: zod_1.z.number().nullish(),
    verticalAllowed: zod_1.z.boolean(),
    speedMaxVertical: zod_1.z.number().nullish(),
    accelerationMaxVertical: zod_1.z.number().nullish(),
    travelDistanceVertical: zod_1.z.number().nullish(),
    oilResistant: zod_1.z.string(),
    outerJacket: zod_1.z.string(),
});
exports.default = exports.ChainflexSeriesSchema;
//# sourceMappingURL=ChainflexSeriesSchema.js.map